<template>
  <div class="login-form">
    <a-row>
      <a-col :span="6"><a class="emailTitle">{{ t('validate.str9') }}</a></a-col>
      <a-col :span="18" v-show="!formEmail.email"><span style="color:red; font-size:14px;">{{ t('validate.str10')
      }}</span></a-col>
    </a-row>
    <a-form :model="formEmail">
      <a-form-item>
        <a-input class="login-input" type="tel" :maxLength="11" v-model:value="formEmail.email" :disabled="true"
          :placeholder="t('login.placeholderStr6')">
          <template #prefix>
            <mail-outlined style="margin-right: 15px" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item v-bind="validateInfos.code">
        <a-row class="login-input">
          <a-col :span="11">
            <a-input type="tel" :maxLength="6" v-model:value="formEmail.code" class="login-input"
              :disabled="!formEmail.email" :placeholder="t('login.placeholderStr4')"></a-input>
          </a-col>
          <a-col :span="12">
            <a-button type="primary" :disabled="Disabled || !formEmail.email" @click="getMsg">{{
              Disabled ? btnTxt :verificationCode }}</a-button>
          </a-col>
        </a-row>
      </a-form-item>
      <slot name="changeAccount"></slot>
    </a-form>
    <slot name="login"></slot>
  </div>
</template>

<script lang="ts">
import {
  MailOutlined,
} from "@ant-design/icons-vue";
import { defineComponent, ref, reactive, computed } from "vue";
import { sendEmailCode } from "@/utils/api";
import { message as Message } from "ant-design-vue";
import { countDown, debounce } from "@/utils/common";
import { Form } from "ant-design-vue";
import { rulesVerifyEmail } from "@/utils/validate";
import { useStore } from "vuex"
import { useI18n } from 'vue-i18n'
const useForm = Form.useForm;
interface FormEmail {
  code: string;
  email: string;
  baseUrl: string
}
export default defineComponent({
  components: {
    MailOutlined,
  },
  props: ['verifyProp'],
  setup(props) {
    const { t } = useI18n()
    const Disabled = ref(false)
    const store = useStore();
    const btnTxt = ref('')
    const verificationCode = computed(() => {
      return t('login.verificationCode')
    })
    const formEmail = reactive<FormEmail>({ code: "", email: props.verifyProp.email, baseUrl: store.getters['getBaseUrl'] });
    const getMsg = debounce(async () => {
      await sendEmailCode({ baseUrl: store.getters['getBaseUrl'], email: formEmail.email });
      Message.success(t('iphone.warnStr2'));
      countDown(60, (time: any) => {
        time ? btnTxt.value = `${t('iphone.warnStr3')}（${time}）` : btnTxt.value = `${t('iphone.warnStr3')}`
        time ? Disabled.value = true : Disabled.value = false
      })
    }, 1000);
    const loginPlatform = () => {
      return new Promise((reslove, reject) => {
        validate().then(() => {
          reslove({ formEmail, params: props.verifyProp.params })
        }).catch(() => {
          reject()
        })
      })
    };

    const { validate, validateInfos } = useForm(formEmail, rulesVerifyEmail); // 用户名密码
    return {
      formEmail,
      getMsg,
      loginPlatform,
      validate,
      validateInfos,
      btnTxt,
      Disabled,
      verificationCode,
      t
    };
  },
});
</script>
<style scoped lang="less" src="@/style/common.less"></style>
